import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { refreshStorageLogList } from "../reducers/storageSlice";
import {
  getClientInventoryCrewListAction,
  getInventoryCrewDetailsAction,
  getCrewSurveyItemsAction,
  deleteInventoryAction,
  sendCrewOtpAction,
  sendInventoryCrewSendLinkAction,
  setClientInventoryCrewListAction,
  setCrewTokenInValidAction,
  setInventoryCrewDetailsAction,
  setCrewSurveyItemsAction,
  setCrewInventoryPhotoUploadAction,
  setInventoryNoteUpdatedAction,
  setDeleteInventoryResponseAction,
  setSendCrewOtpAction,
  setSendInventoryCrewSendLinkAction,
  setUpdateInventoryCrewDetailsAction,
  setUrlVerifyInventoryCrewLinkAction,
  setVerifyCrewOtpAction,
  updateInventoryCrewDetailsAction,
  uploadCrewInventoryPhotoAction,
  urlVerifyInventoryCrewLinkAction,
  verifyCrewOtpAction,
} from "../reducers/inventoryCrewSlice";
import axios from "axios";
import { setUserAction } from "../reducers/userSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

/* ✅ v2 base URL, read once here so every saga below can reuse it */
const V2_CONFIG = { baseURL: process.env.REACT_APP_BASE_URL_V2 };

function* getClientInventoryCrewListSaga({ payload }: any): any {
  const { removalLeadId } = payload;
  try {
    yield put(setLoaderAction(true));
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/inventory-crews?removalLeadId=${removalLeadId}`,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
      yield put(setLoaderAction(false));
      yield put(setClientInventoryCrewListAction(res.data));
    }
  } catch (error: any) {
    yield put(setLoaderAction(false));
    yield put(setNotificationAction(handleError(error)));
  }
  yield put(setLoaderAction(false));
}

function* sendInventoryCrewSendLinkSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      "storage/inventory-crews/send-link",
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSendInventoryCrewSendLinkAction(true));
      yield put(refreshStorageLogList());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    yield put(setSendInventoryCrewSendLinkAction(false));
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* urlVerifyInventoryCrewLinkSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { token, tenantId, contractId } = payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `public/crews/verify-token?token=${token}&tenant_id=${tenantId}&contract_id=${contractId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.data) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCrewTokenInValidAction(false));
      yield put(setUrlVerifyInventoryCrewLinkAction(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    yield put(setCrewTokenInValidAction(true));
    yield put(setUrlVerifyInventoryCrewLinkAction(null));
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* sendCrewOtpSaga({ payload }: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const response = yield call<any>(
      callAPI,
      { payload },
      "post",
      `public/crews/send-otp`,
      "",
      V2_CONFIG,
    );
    console.log("response-", response);
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setSendCrewOtpAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendCrewOtpAction(false));
  }
  yield put(setLoaderAction(false));
}

function* verifyCrewOtpSaga({ payload }: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const response = yield call<any>(
      callAPI,
      { payload },
      "post",
      `public/crews/verify-otp`,
      "",
      V2_CONFIG,
    );
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setVerifyCrewOtpAction(true));
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response?.data?.accessToken;
    //   yield put(setUserAction(response?.data));
      //   yield put(setAccountActivationMessage(null));
      localStorage.setItem("user", JSON.stringify(response?.data));
      localStorage.setItem(
        "nextAction",
        JSON.stringify(response?.data?.nextAction),
      );
      localStorage.setItem("isSeenNotification", "false");
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setVerifyCrewOtpAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getInventoryCrewDetailsSaga({ payload }: any): any {
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { contractId,role } = payload;
  const storedUser = localStorage.getItem("user");
    console.log("storedUser",storedUser);
  try {
    yield put(setLoaderAction(true));
    let url = "";
    if(role?.toLowerCase() === "crew") {
      url = `storage/crews/contracts/${contractId}/inventory`;
    } else {
      url = `storage/contracts/${contractId}/inventory`;
    }
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      url,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
      yield put(setLoaderAction(false));
      yield put(setInventoryCrewDetailsAction(res.data));
    }
  } catch (error: any) {
    yield put(setLoaderAction(false));
     error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCrewSurveyItemsSaga({ payload }: any): any {
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { inventoryId, role } = payload;
  try {
    yield put(setLoaderAction(true));
     let url = "";
    if(role?.toLowerCase() === "crew") {
      url = `storage/crews/inventories/${inventoryId}/survey-items`;
    } else {
      url = `storage/inventories/${inventoryId}/survey-items`;
    }
    const response = yield call<any>(
      callAPI,
      {},
      "get",
      url,
      "",
      V2_CONFIG,
    );
    const responseData = response?.data;
    response && handleSuccess(response);
    const items = Array.isArray(responseData)
      ? responseData
      : responseData?.items ?? responseData?.surveyItems ?? [];
    yield put(setCrewSurveyItemsAction(items));
    yield put(setLoaderAction(false));
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCrewSurveyItemsAction([]));
  }
  yield put(setLoaderAction(false));
}

function* updateInventoryCrewDetailsSaga({ payload }: any): any {
  const { inventoryId, role, inventoryData, isVerificationNoteUpdate } = payload;
  console.log("updateInventoryCrewDetailsSaga payload", payload);
  try {
    yield put(setLoaderAction(true));
    let url = "";
    if(role?.toLowerCase() === "crew") {
      url = `storage/crews/inventories/${inventoryId}`;
    }else {
      url = `storage/inventories/${inventoryId}`;
    }
    const res = yield call<any>(
      callAPI,
      { payload: inventoryData },
      "post",
      url,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
       res && handleSuccess(res);
      yield put(setLoaderAction(false));
      yield put(refreshStorageLogList());
      if (isVerificationNoteUpdate) {
        yield put(setInventoryNoteUpdatedAction(true));
      } else {
        yield put(setUpdateInventoryCrewDetailsAction(true));
      }
    }
  } catch (error: any) {
    yield put(setLoaderAction(false));
    if (isVerificationNoteUpdate) {
      yield put(setInventoryNoteUpdatedAction(false));
    } else {
      yield put(setUpdateInventoryCrewDetailsAction(false));
    }
     error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* uploadCrewInventoryPhotoSaga({ payload }: any): any {
  const { file } = payload;
  const fileType = file.type || "application/octet-stream";
  const fileName = encodeURIComponent(file.name);
  const encodedFileType = encodeURIComponent(fileType);
  try {
     let url =''
    const storedUser = localStorage.getItem("user");
    console.log("storedUser",storedUser);
    if (storedUser) {
      console.log("storedUser-291",storedUser);
      const user = JSON.parse(storedUser);
      const isCrew = user?.user?.roles?.some(
        (role: string) => role?.toLowerCase() === "crew"
      );
      if(isCrew){
        url=`storage/crews/upload?fileName=${fileName}&fileType=${encodedFileType}`;
      } else{
        url =`storage/upload?fileName=${fileName}&fileType=${encodedFileType}`;
      }
    }
    const response = yield call<any>(
      callAPI,
      {},
      "get",
      url,
      "",
      V2_CONFIG,
    );
    const uploadUrl = response?.data?.uploadURL;
    const key = response?.data?.key;

    if (!uploadUrl || !key) {
      throw new Error("The photo upload URL was not returned.");
    }

    yield call<any>(
      callAPI,
      { payload: file },
      "put",
      uploadUrl,
      fileType,
    );
    if(response){
      response && handleSuccess(response);
      yield put(
        setCrewInventoryPhotoUploadAction({
          fileName: file.name,
          key,
          url: response?.data?.url ?? response?.data?.publicUrl ?? "",
          isUploading: false,
          hasError: false,
        }),
      );
    }
  } catch (error: any) {
    error?.response && handleError(error.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setNotificationAction({
      message: ["Unable to upload inventory photo."],
      severity: "error",
    }));
    yield put(
      setCrewInventoryPhotoUploadAction({
        fileName: file.name,
        key: "",
        url: "",
        isUploading: false,
        hasError: true,
      }),
    );
  }
}

function* deleteInventorySaga({ payload }: any): any {
  const { inventoryId } = payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const response = yield call<any>(
      callAPI,
      {},
      "delete",
      `storage/inventories/${inventoryId}`,
      "",
      V2_CONFIG,
    );
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setDeleteInventoryResponseAction(true));
      yield put(refreshStorageLogList());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

export function* watchInventoryCrew() {
  yield takeLatest<any>(
    getClientInventoryCrewListAction,
    getClientInventoryCrewListSaga,
  );
  yield takeLatest<any>(
    sendInventoryCrewSendLinkAction,
    sendInventoryCrewSendLinkSaga,
  );
  yield takeLatest<any>(
    urlVerifyInventoryCrewLinkAction,
    urlVerifyInventoryCrewLinkSaga,
  );
  yield takeLatest<any>(sendCrewOtpAction, sendCrewOtpSaga);
  yield takeLatest<any>(verifyCrewOtpAction, verifyCrewOtpSaga);
  yield takeLatest<any>(getInventoryCrewDetailsAction, getInventoryCrewDetailsSaga);
  yield takeLatest<any>(getCrewSurveyItemsAction, getCrewSurveyItemsSaga);
  yield takeLatest<any>(updateInventoryCrewDetailsAction, updateInventoryCrewDetailsSaga);
  yield takeLatest<any>(uploadCrewInventoryPhotoAction, uploadCrewInventoryPhotoSaga);
  yield takeLatest<any>(deleteInventoryAction, deleteInventorySaga);
}
